export default [
    {
        img:"ar1.jpg",
        info:"ECG KIT"
    },
    {
        img:"ar2.jpg",
        info:"Customised ECG KIT BAG"
    },
    {
        img:"ar3.jpg",
        info:"ECG KIT"
    },
    {
        img:"ar4.jpg",
        info:"Standard Charger"
    },
    {
        img:"ar5.jpg",
        info:"10 lead ECG probe"
    },
    {
        img:"ar6.jpg",
        info:"Chest and Limb electrodes"
    },
    {
        img:"impdevice.png",
        info:"Portable 12 Channel ECG device"
    },
    {
        img: "step3.jpg",
        info:"Mobile App"
    },
    {
        img: "autor1.jpg",
        info:"Sample ECG report in pdf format"
    }
]